import { StyleSheet } from 'aphrodite';
import { brandPrimary, mention, white } from '../../../web/styles/colors';
import { BreakPoints } from '../../../web/styles/styles';

const containerHeaderHeight = 125;

export const styleSheet = StyleSheet.create({
	body: {
		background: white,
		height: `calc(100% - ${containerHeaderHeight}px)`,
		textAlign: 'center',
		[BreakPoints.phoneCompactWidth]: {
			borderRadius: 0,
		},
		minHeight: '75vh',
	},
	container: {
		boxSizing: 'border-box',
	},
	content: {
		margin: '0 auto',
		width: '100%',
		[BreakPoints.forMinWidth(768)]: {
			boxShadow: `0 0 6px 0 rgba(139,139,139,0.10)`,
			width: '100%',
			paddingTop: 0,
		},
	},
	footer: {
		alignItems: 'center',
		color: white,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 12,
		justifyContent: 'center',
		background: white,
		paddingBottom: 24,
		paddingTop: 64,
	},
	header: {
		alignItems: 'center',
		background: mention,

		display: 'flex',
		flexDirection: 'column',
		fontSize: 24,
		height: containerHeaderHeight,
		justifyContent: 'center',
	},
	mainLogo: {
		width: 158,
	},
	poweredBy: {
		marginBottom: 8,
		color: brandPrimary,
		fontWeight: 600,
	},
});
